import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRouteSnapshot, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { SystemService } from './shared/services/system.service';
import { ConfigService } from './config/config.service';
import { Version } from './shared/classes/version';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

    title: string = 'Welcome to Axxess';
    private prefix: string = 'Axxess';
    buildVersion: Version;
    isQA: boolean =  false;

    constructor(private systemService: SystemService, private router: Router, private titleService: Title,
                private configService: ConfigService) {
    }

    ngOnInit() {
        this.systemService.getVersion().subscribe(data => {
            this.buildVersion = new Version(data.major, data.minor, data.buildNumber, data.gitHash, data.gitBranch);
        });
        this.isQA = this.configService.isQA;
        this.titleService.setTitle(this.title);

        // Update title when navigation ends
        this.router.events.subscribe((event) => { //fires on every URL change
            if (event instanceof NavigationEnd) {
                this.title = this.getDeepestTitle(this.router.routerState.snapshot.root);
                this.titleService.setTitle(`${this.prefix} | ${this.title}`);
            }
        });
    }

    private getDeepestTitle(routeSnapshot: ActivatedRouteSnapshot): string {
        var title = routeSnapshot.data ? routeSnapshot.data['title'] : '';
        if (routeSnapshot.firstChild) {
            title = this.getDeepestTitle(routeSnapshot.firstChild) || title;
        }

        return title || '';
    }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts